import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["group"]

  connect() {
    // Future: initialize drag-and-drop
  }
}
